export const calculateRefundBreakdown = ({
  amount_paid_self = 0,
  surcharge_amount = 0,
  amount_refunded = 0,
  refundAmount = 0
}) => {
  const totalOriginalAmount = amount_paid_self + amount_refunded;
  const baseTotalAmount = Math.max(0, totalOriginalAmount - surcharge_amount);
  const surchargePerBaseUnit = baseTotalAmount > 0 ? surcharge_amount / baseTotalAmount : 0;

  const baseRemaining =
    totalOriginalAmount > 0 ? amount_paid_self * (baseTotalAmount / totalOriginalAmount) : 0;
  const remainingSurcharge = Math.max(0, amount_paid_self - baseRemaining);
  const refundedSurcharge = Math.min(remainingSurcharge, refundAmount * surchargePerBaseUnit);

  return { maxAmount: baseRemaining, refundedSurcharge };
};
